import { api } from '../../core/apiClient.ts';

export interface PageSyncTask { edge: string; after?: string }
export interface PageSyncChunk {
  ok: boolean; count: number; pageIds: string[]; next: PageSyncTask[]; error?: string;
}

/** Each chunk is a new HTTP request with a fresh Worker subrequest budget. */
export async function refreshAllPages(socialAccountId: string, initial?: PageSyncChunk) {
  const pending: PageSyncTask[] = initial ? [...initial.next] : [{ edge: 'me/accounts' }];
  const ids = new Set(initial?.pageIds ?? []);
  const errors: string[] = initial && !initial.ok ? [initial.error ?? 'Page sync failed'] : [];
  const seen = new Set<string>();
  while (pending.length) {
    const task = pending.shift()!;
    const key = JSON.stringify([task.edge, task.after ?? null]);
    if (seen.has(key)) {
      errors.push(`${task.edge}: repeated pagination cursor`);
      continue;
    }
    seen.add(key);
    try {
      const chunk = await api.post<PageSyncChunk>(
        `/api/pages/refresh/${encodeURIComponent(socialAccountId)}`, task);
      if (!chunk.ok) { errors.push(`${task.edge}: ${chunk.error ?? 'Page sync failed'}`); continue; }
      for (const id of chunk.pageIds) ids.add(id);
      pending.push(...chunk.next);
    } catch (err) {
      errors.push(`${task.edge}: ${err instanceof Error ? err.message : String(err)}`);
    }
  }
  return { ok: errors.length === 0, count: ids.size, pageIds: [...ids], errors };
}
